// FILE: src/hooks/useMatrixClient.js
// Thin read-only hook — exposes the single Matrix client created by matrixUserService.
// No boot logic here; matrixUserService.startForUser() is the sole entry point
// (called by profileStore.login()).

import { useEffect, useState } from 'react';
import { useMatrixStore } from '../state/matrixStore';
import { matrixUserService } from '../components/messaging/matrixUserService';

// ---- Read-only accessors for use outside React render cycle (e.g. TeamModal) ----
export const getGlobalMatrixClient = () => matrixUserService.client || null;
export const getGlobalMatrixService = () => matrixUserService.service || null;
export const getGlobalMatrixReady  = () => Boolean(matrixUserService.isRunning);


export default function useMatrixClient() {
  // Subscribe to connectionState so the hook re-renders when the service starts/stops
  const connectionState = useMatrixStore(s => s.connectionState);

  const [state, setState] = useState(() => ({
    client: matrixUserService.client || null,
    service: matrixUserService.service || null,
    isReady: matrixUserService.isRunning || false,
    error: null,
  }));

  useEffect(() => {
    setState({
      client: matrixUserService.client || null,
      service: matrixUserService.service || null,
      isReady: matrixUserService.isRunning || false,
      error: connectionState === 'error' ? new Error('Matrix connection error') : null,
    });
  }, [connectionState]);

  return state;
}
